import { render, staticRenderFns } from "./board_app.vue.js?vue&type=template&id=3e8581c8&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./board_app.vue?vue&type=template&id=3e8581c8&vue3"
import script from "./board_app.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./board_app.vue?vue&type=script&lang=js&vue3"
export * from "./board_app.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./board_app.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports